/* KYRIOS v17 · interacciones globales (21-10-2026) */
(function () {
  'use strict';
  var d = document, w = window, html = d.documentElement;
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = w.matchMedia('(hover: hover) and (pointer: fine)').matches;
  html.classList.add('k17-js');

  function qsa(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function raf(fn) { var t = 0; return function () { if (t) return; t = requestAnimationFrame(function () { t = 0; fn(); }); }; }

  /* ---------- Header: estado al hacer scroll + barra de progreso ---------- */
  var bar = d.createElement('div');
  bar.className = 'k17-progress';
  bar.setAttribute('aria-hidden', 'true');
  d.body.appendChild(bar);
  var hdr = d.querySelector('.kyrios-hdr');
  function setHdrH() { if (hdr) html.style.setProperty('--k17-hdr-h', hdr.offsetHeight + 'px'); }
  var onScroll = raf(function () {
    var y = w.scrollY || 0, max = d.documentElement.scrollHeight - w.innerHeight;
    html.classList.toggle('k17-scrolled', y > 8);
    bar.style.setProperty('--p', max > 0 ? Math.min(1, y / max).toFixed(4) : 0);
  });
  w.addEventListener('scroll', onScroll, { passive: true });
  w.addEventListener('resize', raf(setHdrH));
  setHdrH(); onScroll();

  /* ---------- Luz que sigue al cursor en tarjetas ---------- */
  if (finePointer) {
    d.addEventListener('pointermove', function (e) {
      var el = e.target.closest && e.target.closest('.k-card, .k17-tile');
      if (!el) return;
      var r = el.getBoundingClientRect();
      el.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      el.style.setProperty('--my', (e.clientY - r.top) + 'px');
    }, { passive: true });
  }

  /* ---------- Botones magnéticos ---------- */
  if (finePointer && !reduce) {
    qsa('[data-magnetic]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.18, y = (e.clientY - r.top - r.height / 2) * 0.28;
        el.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- Reveal y contadores ---------- */
  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-k17-count')) || 0;
    var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
    var pre = el.getAttribute('data-pre') || '', suf = el.getAttribute('data-suf') || '';
    var fmt = function (v) {
      var s = v.toFixed(dec);
      if (!dec) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      else s = s.replace('.', ',');
      return pre + s + suf;
    };
    if (reduce) { el.textContent = fmt(target); return; }
    var t0 = 0, dur = 1600;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 4);
      el.textContent = fmt(target * e);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  if ('IntersectionObserver' in w) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        if (el.hasAttribute('data-k17-count')) countUp(el);
        else el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    qsa('[data-k17-reveal], [data-k17-count]').forEach(function (el) { io.observe(el); });
  } else {
    qsa('[data-k17-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Hero ---------- */
  qsa('.k17-hero').forEach(function (hero) {
    requestAnimationFrame(function () { requestAnimationFrame(function () { hero.classList.add('is-in'); }); });

    // palabras rotativas del titular
    var rot = hero.querySelector('.k17-rot');
    var words = rot ? qsa('span', rot) : [];
    var wi = 0;
    function showWord(i) { words.forEach(function (s, k) { s.classList.toggle('is-on', k === i); }); }
    if (words.length) showWord(0);

    // foco de luz que sigue al cursor
    if (finePointer && !reduce) {
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        hero.style.setProperty('--hx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        hero.style.setProperty('--hy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      }, { passive: true });
    }

    // video: carga diferida, fuente según pantalla, pausa fuera de pantalla
    var video = hero.querySelector('video');
    var items = qsa('.k17-now__item', hero), dots = qsa('.k17-now__dots button', hero);
    var beat = parseFloat(hero.getAttribute('data-beat') || '3');
    var current = -1;
    function setBeat(i) {
      if (i === current) return;
      current = i;
      items.forEach(function (it, k) { it.classList.toggle('is-on', k === i); it.setAttribute('aria-hidden', k === i ? 'false' : 'true'); it.tabIndex = k === i ? 0 : -1; });
      dots.forEach(function (b, k) { b.classList.toggle('is-on', k === i); b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (words.length) showWord(i % words.length);
    }
    setBeat(0);

    var saveData = navigator.connection && (navigator.connection.saveData || /2g/.test(navigator.connection.effectiveType || ''));
    var clock = null;
    function startClock() {
      // sin video (movimiento reducido / ahorro de datos): rota cada beat
      if (clock || reduce) return;
      clock = setInterval(function () { setBeat((current + 1) % Math.max(1, items.length)); }, beat * 1000);
    }
    if (video && !reduce && !saveData) {
      var mobile = w.matchMedia('(max-width: 749px)').matches;
      // iPhone/iPad y Safari: primero MP4 (H.264), que reproducen siempre; el resto prefiere WebM (más liviano)
      var appleish = /iP(hone|ad|od)|Macintosh/.test(navigator.userAgent) && /Safari/.test(navigator.userAgent) && !/Chrome|CriOS|FxiOS|EdgiOS/.test(navigator.userAgent);
      var webm = [video.getAttribute(mobile ? 'data-webm-m' : 'data-webm'), 'video/webm'];
      var mp4 = [video.getAttribute(mobile ? 'data-mp4-m' : 'data-mp4'), 'video/mp4'];
      (appleish ? [mp4, webm] : [webm, mp4]).forEach(function (s) {
        if (!s[0]) return;
        var so = d.createElement('source'); so.src = s[0]; so.type = s[1]; video.appendChild(so);
      });
      video.muted = true; video.defaultMuted = true;
      video.setAttribute('muted', ''); video.setAttribute('playsinline', ''); video.setAttribute('webkit-playsinline', '');
      video.setAttribute('autoplay', '');
      video.preload = 'auto';
      video.load();
      video.addEventListener('playing', function () { video.classList.add('is-playing'); hero.classList.remove('is-static'); }, { once: true });
      video.addEventListener('timeupdate', function () {
        if (!items.length) return;
        setBeat(Math.floor(video.currentTime / beat) % items.length);
      });
      var tryPlay = function () {
        var p = video.play();
        if (p && p.catch) p.catch(function () { hero.classList.add('is-static'); startClock(); });
      };
      // si el navegador bloquea el autoplay (p. ej. modo de bajo consumo en iPhone), reintenta con el primer gesto
      var kick = function () { if (video.paused) tryPlay(); };
      ['touchstart', 'pointerdown', 'scroll'].forEach(function (ev) { w.addEventListener(ev, kick, { passive: true, once: true }); });
      setTimeout(function () { if (video.paused || video.readyState < 2) { hero.classList.add('is-static'); startClock(); } }, 3500);
      var vio = new IntersectionObserver(function (en) {
        en.forEach(function (x) { if (x.isIntersecting) tryPlay(); else video.pause(); });
      }, { threshold: 0.15 });
      vio.observe(hero);
      dots.forEach(function (b, k) { b.addEventListener('click', function () { try { video.currentTime = k * beat + 0.05; } catch (e) {} setBeat(k); }); });
    } else {
      startClock();
      dots.forEach(function (b, k) { b.addEventListener('click', function () { setBeat(k); }); });
    }
  });

  /* ---------- Ficha: la foto principal se inclina levemente con el cursor ---------- */
  if (finePointer && !reduce) {
    qsa('.kyrios-pdp .k-pdp-stage').forEach(function (stage) {
      var img = stage.querySelector('.k-pdp-stage-img');
      if (!img) return;
      img.style.transition = 'transform .5s cubic-bezier(.22,.8,.18,1)';
      stage.addEventListener('pointermove', function (e) {
        if (stage.classList.contains('is-zoomed')) { img.style.transform = ''; return; }
        var r = stage.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        img.style.transform = 'perspective(900px) rotateY(' + (x * 8).toFixed(2) + 'deg) rotateX(' + (-y * 8).toFixed(2) + 'deg) scale(1.02)';
      });
      stage.addEventListener('pointerleave', function () { img.style.transform = ''; });
    });
  }

  /* ---------- Marquee: duplica la pista para el loop ---------- */
  qsa('.k17-marquee__track').forEach(function (t) {
    if (t.dataset.dup) return;
    t.dataset.dup = '1';
    t.innerHTML += t.innerHTML;
    qsa('a', t).slice(t.children.length / 2).forEach(function (a) { a.setAttribute('aria-hidden', 'true'); a.tabIndex = -1; });
  });

  /* ---------- Video de envío: reproducir solo en pantalla ---------- */
  qsa('[data-k17-autoplay]').forEach(function (v) {
    if (reduce) return;
    var vio = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (x.isIntersecting) {
          if (!v.dataset.loaded) {
            qsa('source[data-src]', v).forEach(function (s) { s.src = s.getAttribute('data-src'); });
            v.load(); v.dataset.loaded = '1';
          }
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else v.pause();
      });
    }, { threshold: 0.2 });
    vio.observe(v);
  });

  /* ---------- Universo 3D: carga el módulo solo cuando se acerca ---------- */
  var uni = d.querySelector('.k17-uni');
  if (uni) {
    var webgl = (function () { try { var c = d.createElement('canvas'); return !!(w.WebGLRenderingContext && (c.getContext('webgl2') || c.getContext('webgl'))); } catch (e) { return false; } })();
    if (!webgl) uni.classList.add('is-fallback');
    else {
      var uio = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        uio.disconnect();
        var s = d.createElement('script');
        s.type = 'module';
        s.src = (w.K17 && w.K17.three) || uni.getAttribute('data-module');
        s.onerror = function () { uni.classList.add('is-fallback'); };
        d.body.appendChild(s);
      }, { rootMargin: '600px 0px' });
      uio.observe(uni);
    }
  }
})();
